module.exports = __webpack_public_path__ + "img/eye.b51ab55d.svg";